import * as angular from "angular";
import {IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {DashboardsRequestsService} from "./dashboards-requests.service";
import {DashboardsAlertsService} from "./dashboards-alerts.service";
import {DashboardModel} from "../models/dashboard.model";
import {WidgetDatasourceEnum} from "../enums/widget-datasource.enum";

export class DashboardsServiceService {

  /* @ngInject */
  constructor(private $q: IQService, private dashboardsRequestsService: DashboardsRequestsService, private dashboardsAlertsService: DashboardsAlertsService,
              private bringozLoaderService: BringozLoaderService, private $log) {
  }

  createDashboard(dashboard: DashboardModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.dashboardsRequestsService.createDashboard(dashboard)
      .then((dashboard) => {
        this.dashboardsAlertsService.createDashboardSuccess();
        deferred.resolve(dashboard)
      })
      .catch((error) => {
        this.dashboardsAlertsService.createDashboardError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateDashboard(dashboard: DashboardModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.dashboardsRequestsService.updateDashboard(dashboard)
      .then((dashboard) => {
        this.dashboardsAlertsService.updateDashboardSuccess();
        deferred.resolve(dashboard)
      })
      .catch((error) => {
        this.dashboardsAlertsService.updateDashboardError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  deleteDashboard(dashboardId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.dashboardsRequestsService.deleteDashboard(dashboardId)
      .then((dashboard) => {
        this.dashboardsAlertsService.deleteDashboardSuccess();
        deferred.resolve(dashboard)
      })
      .catch((error) => {
        this.dashboardsAlertsService.deleteDashboardError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getDashboardById(dashboardId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.dashboardsRequestsService.getDashboardById(dashboardId)
      .then((dashboard) => {
        deferred.resolve(dashboard)
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getDashboardWidgetData(dataSource: WidgetDatasourceEnum, queryParams) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.dashboardsRequestsService.getDashboardWidgetData(dataSource, queryParams)
      .then((data) => {
        deferred.resolve(data)
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getDashboardWidgetDataPost(dataSource: WidgetDatasourceEnum, queryParams) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.dashboardsRequestsService.getDashboardWidgetDataPost(dataSource, queryParams)
      .then((data) => {
        deferred.resolve(data)
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  changeDashboardPublicState(dashboardId: string, isPublic: boolean) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.dashboardsRequestsService.changeDashboardPublicState(dashboardId, isPublic)
      .then((data) => {
        deferred.resolve(data)
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

}

angular
  .module('bringoz.admin.dashboards')
  .service('dashboardsServiceService', DashboardsServiceService);
